import React from 'react'
import './ModalPartners.css'
import { useState, useEffect } from 'react'
import fetchData from '../../../function/fetchData'
import { IoClose } from 'react-icons/io5';

const ModalPartners = ({state, setShowModalMenu}) => {
    const [listOfParners, setListOfPartners] = useState([]) 
  
    // Stáhne partnerovo číslo aby ukázal který bylo nastaveno naposledy
    useEffect( () => {
        fetchData(state.server + "api2/getExternalParner.php" , {token: state.tokenOfDriver, payload: "GET"})
        .then( (res)=> {
            if(res.status === "OK"){
                if(res.info === "OK") {
                    setListOfPartners(res.partnersList)
         
                } else {
                    alert(res.info)
                }
            } else {
                alert("server neodpovídá")
            }
        })
    }, [])



    // Uloží změnu
    const handleChangeTel = (name, tel) => {
        fetchData(state.server + "api2/setExternarPartner.php" , {token: state.tokenOfDriver, payload: "SET" , tel: tel, name:name})
        .then( (res)=> {
            console.log(res)
            if(res.status === "OK"){
                if(res.info === "OK") {
                    alert("Byl nastaven partner: " + name)
                    setShowModalMenu(false)
                } else {
                    alert(res.info)
                }
            } else {
                alert("server neodpovídá")
            }
        })
    }

    // Uloží změnu
    const handleNoPartnerSet = () => {
        fetchData(state.server + "api2/setExternarPartner.php" , {token: state.tokenOfDriver, payload: "REMOVE" })
        .then( (res)=> {
            console.log(res)
            if(res.status === "OK"){
                if(res.info === "OK") {
                    alert("Byl odebrán externí partner")
                    setShowModalMenu(false)
                } else {
                    alert(res.info)
                }
            } else {
                alert("server neodpovídá")
            }
        })
    }


  return (
    <div className='ModalMenuContainer'>
                    <IoClose size={30} color={"grey"} className="closeIcon" onClick={()=>setShowModalMenu(false)}/>
                     <div className="titleOfModal">
                            <h3>Partneři</h3>
                    </div>
                    <div className="partnersContent">
                        {listOfParners.map( (onePartner) => {
                            const isActive = parseInt( onePartner.active )
                            return (
                                <div key={onePartner.tel} 
                                    style={isActive === 1 ? {background: onePartner.color ,boxShadow: "0 0 1px 5px black" } : {background: onePartner.color  }} 
                                    className="onePartner"
                                    onClick={() => handleChangeTel(onePartner.name ,onePartner.tel)}
                                >
                                    <h2>{onePartner.name}</h2>
                                    <p>{onePartner.tel}</p>
                                </div>
                            )
                        })}
                        <div 
                            style={{background: "red"  }} 
                            className="onePartner"
                            onClick={handleNoPartnerSet}
                        >
                            <h2>Bez Pratnera</h2>
                        </div>
                    </div>
                </div>
  )
}

export default ModalPartners
